<template>
  <div v-cloak>

    
    <div>

    <b-spinner v-if="isBusy"></b-spinner>

    <div v-show="!errored">

  <b-container style="max-width: 1000px;"> <!-- container for tab control ----->

      <b-tabs v-model="tabIndex" active-nav-item-class="font-weight-bold"  >
        <b-tab no-body >
          <template v-slot:title>
            Issues
          </template>
          
    <!-- issues log--------------------------------------------------------------------------------------------------->
<b-container v-show="!errored" class="p-2 border" style="max-width: 1000px;background-color:whitesmoke;" fluid>
  <b-row align-v="center">
    <b-col cols="6" class="d-flex align-items-center">
      <b-button variant="outline-dark" size="sm" v-on:click="newIssue()" class="ml-3 font-weight-bold"><b>+</b> New Issue</b-button>
    </b-col>
    
    <b-col cols="3">
      <b-form-group label="Type:" label-for="type-select" label-cols="auto" label-align-sm="right" label-size="sm" class="mb-0 mr-2" label-class="font-weight-bold">
        <b-form-select id="type-select" v-model="selectedType" :options="typeOptions" size="sm"></b-form-select>
      </b-form-group>
    </b-col>

    <b-col cols="3">
      <b-form-group label="Status:" label-for="status-select" label-cols="auto" label-align-sm="right" label-size="sm" class="mb-0 mr-2" label-class="font-weight-bold">
        <b-form-select id="status-select" v-model="selectedStatus" :options="statusOptions" size="sm"></b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</b-container>

      <div id="issuestable">
        <b-table
          selectable
          select-mode="single"
          small
          striped
          outlined
          head-variant="light"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filterCriteria"
          :filter-function="customFilter"
          :busy="isBusy"
          :items="data"
          :fields="fields"
          @filtered="onFiltered"
          @row-selected="rowSelected"
        >

        </b-table>

      </div>
          
      <b-pagination v-show="totalRows>perPage"
      v-model="currentPage"
      align="center"
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="issuestable"
      hide-ellipsis>
    </b-pagination>
   <!-- end of issues log------------------------------------------------------------------------------------------------->


        </b-tab>

        <b-tab no-body>
          <template v-slot:title>
            Print View
          </template>

<!-- printable issues log------------------------------------------------------------------------------------------------->

  <b-container v-show="!errored" class="p-2 border" style="max-width: 1000px;background-color:whitesmoke;" fluid>
    <b-row align-v="center">
      <b-col cols="6" class="d-flex align-items-center">
        <b-button variant="outline-dark" size="sm" v-on:click="printIssueLog()" class="ml-3 font-weight-bold"> &#x1F5A8; Print</b-button>
      </b-col>
      
      <b-col cols="3">
        <b-form-group label="Type:" label-for="type-select" label-cols="auto" label-align-sm="right" label-size="sm" class="mb-0 mr-2" label-class="font-weight-bold">
          <b-form-select id="type-select" v-model="selectedType" :options="typeOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <b-form-group label="Status:" label-for="status-select" label-cols="auto" label-align-sm="right" label-size="sm" class="mb-0 mr-2" label-class="font-weight-bold">
          <b-form-select id="status-select" v-model="selectedStatus" :options="statusOptions" size="sm"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>


  <b-container class="issuesprint">

    <div id="printable">

  <div class="page-header">

   <!-- Page Header -->
    <div class="mt-2 mb-2" style="display: flex; flex-direction: column; align-items: flex-start; position: relative;">
      <div style="display: flex; flex-direction: column; align-items: center;">
        <img alt="Canem" src="@/assets/images/canem-logo.svg" height="28px">
        <div class="ml-2"> <b style="font-size: 1.1rem;">Site Issue Log</b> </div>
      </div>
      
      <div style="position: absolute; top: 0; right: 0; text-align: right;">
        <b v-if="project" style="font-size: 1.3rem;">{{projectId}} {{project.description}}</b>
      </div>
    </div>

    <div>
      <!-- Column Header -->
      <div class="header">
        <div class="column header-item">Issue ID/Date</div>
        <div class="column header-item">Title/Description</div>
        <div class="column header-item">Type/Responsible</div>
        <div class="column header-item">Status</div>
      </div>

    </div>
  </div>
      <!-- Items -->
    <div class="content">
      <div v-for="item in printViewData" :key="item.id" class="item-wrapper">
        <div class="item-container">
          <div class="column">
            <div class="bold">{{ item.id }}</div>
            <div>{{ $moment(item.issueDate).format('MMM D YYYY') }}</div>
          </div>
          <div class="column description-column">
            <div class="bold">{{ item.title }}</div>
            <div>{{ item.description }}</div>
          </div>
          <div class="column">
            <div>{{ item.issueType }}</div>
            <div>{{ item.responsible }}</div>
          </div>
          <div class="column">
            <div>{{ item.status }}</div>
          </div>
        </div>
        <hr class="item-separator" />
      </div>
    </div>

</div> 

  </b-container>

<!-- --------------------------------------------------------------------------------------------------------------------->

        </b-tab>
        
      </b-tabs>
 
  </b-container>   

      <div v-if="!isBusy&data.length<1" class="mx-auto"> (No Issues Logged) </div> 

    </div>

  </div>
 

    <div v-if="errored">
      <p class="text-danger">An error occurred loading data.</p>
      <p>{{ error }}</p>
      <p>
        <b-button type="button" @click="reload">Reload</b-button>
      </p>
    </div>
    
    <!-- The modal Issue -->
    <b-modal
      :id="'Issue'+projectId"
      :title="'Issue '+selectedId"
      size="lg"
      hide-footer
      scrollable
      @hidden="issueClosed"
    >
      <Issue :issueId="selectedId" :issue="selectedIssue" @dirty="dirtyIssue" > </Issue>
    </b-modal>

    <!-- The modal Issue - NewIssue ------------------------------------->
    <b-modal
      :id="'NewIssue'+projectId"
      title="New Issue"
      size="lg"
      hide-footer
    >
      <Issue :issueId=0 :issue="newItem"  @add="addIssue" > </Issue>
    </b-modal>
    <!-- ------------------------------------------------------------- -->


  </div>

</template> 

<script>
import Issue from "@/components/journal/Issue.vue";

export default {
  name: "Issues",
  props: {},
  components: {
    Issue
  },

  data: function() {
    return {
      state: this.$store.state,
      projectId: this.$route.params.id, 
      issueId: 0,
      project: null,
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      filter: null,
      selectedIssue: [],
      selectedId : 0,
      newItem: { 
        issueDate: null,
        title: "", 
        status: "Open",
        issueType:"Internal",
        priority: "Normal",
        projectId: "",
        responsible: "",
        description: ""
          },
      isDirtyIssue: false,
      isBusy: true,
      data: [],
      modules: [],
      dataRows: 0,
      selectedOptions: ['Open'],
      
      selectedStatus: 'Open',  // Default selected status
      statusOptions: [
        { value: 'All', text: 'All' },
        { value: 'Open', text: 'Open' },
        { value: 'Resolved', text: 'Resolved' }
      ],      

      selectedType: 'All',
      typeOptions: [
        { value: 'All', text: 'All' },
        { value: 'Internal', text: 'Internal' },
        { value: 'External', text: 'External' }        
      ],

      loading: true,
      loaded: false,
      errored: false, 
      error: "",
      tabIndex: 0,

      fields: [
        {
          key: "id",
          sortable: true,
          label: "ID",
          isRowHeader: true
        },
        {
          key: "issueDate",
          sortable: true,
          label: "Date",
          formatter: value => {
              return this.$moment(value).format("MMM D YYYY"); 
          }
        },
        {
          key: "title",
          sortable: true,
          label: "Issue",
        },        
        {
          key: "issueType",
          sortable: true,
          label: "Type",
        },
        {
          key: "status",
          sortable: true,
          label: "Status",
          class: "text-center"
        } 
      ]
    };
  },

 computed: {
     
  filterCriteria() {

    if (this.selectedStatus === 'All' && this.selectedType === 'All') {
        return null; // No filter applied
      }
      return {
        type: this.selectedType !== 'All' ? this.selectedType : null,
        status: this.selectedStatus !== 'All' ? this.selectedStatus : null
        
      };
    },

  printViewData() {
    return this.data
      .filter(item => {
        // Filter by type
        if (this.selectedType !== 'All') {
          if (item.issueType !== this.selectedType) return false;
        }
        
        // Filter by status
        if (this.selectedStatus !== 'All') {
          if (item.status !== this.selectedStatus) return false;
        }
        
        return true;
      })
      .sort((a, b) => a.id - b.id);
  },

  },

methods: {

  customFilter(row,criteria) {
    
      if (!criteria) {
        return true; // No filter, show all items
      }

      const statusMatch = criteria.status ? row.status === criteria.status : true;
      const typeMatch = criteria.type ? row.issueType === criteria.type : true;
      
      return statusMatch && typeMatch;
  },

  printIssueLog() {

      // Pass the element id here
      this.$htmlToPaper('printable');

  },

  reload() {
      this.errored = false;
      this.isBusy = true;
      this.fetchData();
    },
  
  rowSelected(items) {
       if (items.length > 0) {
        this.selectedIssue = items[0];
        this.selectedId = this.selectedIssue.id;
        this.isDirtyIssue = false;
        this.$bvModal.show("Issue"+this.projectId);
       }
    },

  newIssue() {
    //reset new item object
    this.newItem.description = "";
    this.newItem.issueDate = this.$moment().format("YYYY-MM-DD");
    this.newItem.issueType = "Internal";
    this.newItem.priority = "Normal";
    this.newItem.projectId = this.projectId;
    this.newItem.responsible = "";
    this.newItem.status = "Open";
    this.newItem.title = "";
    
    this.$bvModal.show("NewIssue"+this.projectId);
  },

  // closeModal() {
  //     this.$bvModal.hide("Issue");
  //   },

   addIssue(issue){
       this.isBusy = true;
       this.$auth.acquireToken().then(token => {
        this.$http
          .post("api/Issues/", issue, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            //insert new issue into issue list 
            var issue = response.data;
            this.data.splice(0,0,issue);
            
          })
          .catch(error => {
            this.errored = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => {
           this.isBusy = false;
           this.$bvModal.hide("NewIssue"+this.projectId);
           
          });
      });     
        
      },  

  dirtyIssue(){
    this.isDirtyIssue = true;
    },

   issueClosed(){
     if (this.isDirtyIssue){
       this.saveEdits(this.selectedIssue);
     }
    },

   saveEdits(issue){
       this.isBusy = true;
       this.$auth.acquireToken().then(token => {
        this.$http
          .put("api/Issues/" + issue.id, issue, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            
          })
          .catch(error => {
            //console.log(error);
            this.errored = true;
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => {
           this.isBusy = false;
           this.$bvModal.hide("Issue");
          
          });
      });     
        
      },  
  
  fetchData() {
      this.$auth.acquireToken().then(token => {
        Promise.all([
          this.$http.get(
            "api/Project/"  + this.projectId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          ),
          this.$http.get(
            "api/issues/project/" + this.projectId,
            {
              headers: { Authorization: "Bearer " + token }
            }
          )
        ])
          .then(results => {

            if (results[0].status == 204){
              this.errored = true;
              this.error = "Project " + this.projectId + ": Not found/No user access ";
            }
            else {
             this.data = results[1].data;
             this.project = results[0].data.project;
             this.modules = results[0].data.modules;
             this.totalRows = this.data.length;
             this.dataRows = this.data.length;
             this.loaded = true;
             this.$store.setItem("project",this.project.projectId + " " + this.project.description);
             this.$store.setItem("projectId", this.project.projectId);

            //check for module assignment
            if (!this.modules.includes('issuelog')){
              this.data = [];
              this.errored = true;
              this.error = this.project.projectId + " Issue Log access not assigned to user.";
            }

            };

          })
          .catch(error => {
            console.log (error);
            this.errored = true;
            this.loaded = false;
            this.data = [];
            if (error.response) {this.error = error.response.statusText};
          })
          .finally(() => (this.isBusy = false));
      });
    },

    setProject() {
      if (this.project){
      this.$store.setItem("projectId", this.project.projectId);
      this.$store.setItem("project",  this.project.projectId + " " + this.project.description );
      this.$store.setItem("modules", this.modules);
      }

    },           

     onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

    setBreadcrumb() {
      this.$store.setItem("breadcrumbs",[ 
      {
        text: this.projectId,
        to: { name: 'Project', params: { Id: this.projectId } }
      },
      {
        text: 'Issue Log'
      }
      ]);
    }
  },

activated: function() {
    this.setBreadcrumb();
    this.setProject();
    },

  mounted: function() {
     
      this.errored = false;
      this.isBusy = true;
      this.fetchData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#issuestable {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  padding-top: 10px;
}

@media (max-width: 400px) {
    #issuestable {
    font-size:.875rem;
    }
}

.col-centered{
    float: none;
    margin: 0 auto;
}

.pagination > li > a,
.pagination > li > span {
    color: darkred;  
}

.issuesprint {
  text-align: left;
  font-size: .85em;
}

</style>

<style scoped>
.header {
  display: grid;
  grid-template-columns: 1fr 4fr 1fr 1fr; /* Same as item columns */
  gap: 10px; /* Space between columns */
  margin-bottom: 10px; /* Space below the header */
  font-weight: bold; /* Bold header text */
  border-top: 1px solid #000; /* Top border for header */
  border-bottom: 1px solid #000; /* Bottom border for header */
}

.column {
  display: flex;
  flex-direction: column;
}

.column div {
  margin-bottom: 5px; /* Space between stacked items */
}

.description-column {
  flex: 4; /* This column takes four times the space of the others */
}

.item-wrapper {
  margin-bottom: 10px; /* Space between items */
}

.item-container {
  display: grid;
  grid-template-columns: 1fr 4fr 1fr 1fr; /* Adjusted column widths */
  gap: 10px; /* Space between columns */
  page-break-inside: avoid; /* Avoid breaking items across pages */
}

.item-separator {
  border: none;
  border-top: 1px solid #ccc; /* Horizontal line */
  margin: 10px 0; /* Space above and below the line */
  width: 100%; /* Ensure the line spans the full width */
}

.bold {
  font-weight: bold;
}

@media print {
    .page-header {
      display: table-header-group;
    }
  
    .content {
      display: table-row-group;
    }
  
    #printable {
      display: table;
      width: 100%;
    }
  
    .item-wrapper {
      page-break-inside: avoid;
    }
  
    @page {
      margin-top: 0;
    }
  
    /* Ensure content after page breaks doesn't overlap with the header */
    .item-wrapper {
      page-break-after: auto;
    }
  
    .item-wrapper:first-child {
      margin-top: 150px; /* Same as the margin-top for #printable */
    }
  }
</style>